import { onMounted, onUnmounted } from 'vue';
import { useItemsStore } from '../stores/items';
import { useToastStore } from '../stores/toast';

export interface KeyboardShortcutsOptions {
  onNew?: () => void;
  onUndo?: () => void;
  onRedo?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  onHelp?: () => void;
}

export function useKeyboardShortcuts(options: KeyboardShortcutsOptions = {}) {
  const itemsStore = useItemsStore();
  const toast = useToastStore();

  function handleKeyDown(event: KeyboardEvent) {
    // 忽略在输入框中的按键
    const target = event.target as HTMLElement;
    const isInputField =
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.contentEditable === 'true';

    // Ctrl/Cmd + Enter: 在输入框中保存
    if (isInputField && (event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      event.preventDefault();
      options.onSave?.();
      return;
    }

    // Escape: 取消编辑或关闭模态框
    if (event.key === 'Escape') {
      event.preventDefault();
      options.onCancel?.();
      return;
    }

    // 如果在输入框中，不处理其他快捷键
    if (isInputField) return;

    // Ctrl/Cmd + N: 新建项目
    if ((event.ctrlKey || event.metaKey) && event.key === 'n') {
      event.preventDefault();
      options.onNew?.();
      return;
    }

    // Ctrl/Cmd + Z: 撤销
    if ((event.ctrlKey || event.metaKey) && event.key === 'z' && !event.shiftKey) {
      event.preventDefault();
      options.onUndo?.();
      return;
    }

    // Ctrl/Cmd + Shift + Z 或 Ctrl/Cmd + Y: 重做
    if (
      ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') ||
      ((event.ctrlKey || event.metaKey) && event.key === 'y')
    ) {
      event.preventDefault();
      options.onRedo?.();
      return;
    }

    // ? 或 / : 打开帮助
    if (event.key === '?' || event.key === '/') {
      event.preventDefault();
      options.onHelp?.();
      return;
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown);
  });

  return {
    // 可以返回一些工具函数
  };
}
